import { violentShake } from '@/styled';
import styled, { keyframes } from 'styled-components';

const rainAnimation = keyframes`
  from {
    transform: translateY(-100vh);
  }
  to {
    transform: translateY(100vh);
  }
`;

const RainDrop = styled.div`
  background: linear-gradient(to bottom, #4a90e2, #5bc6ff);
  width: 10px;
  height: 15px;
  border-radius: 50% 50% 50% 50%/50% 50% 40% 40%;
  position: absolute;
  animation: ${rainAnimation} linear infinite;
`;

const StatusCode = styled.h1`
  font-size: 100px;
`;

const StatusMesssage = styled.h2`
  font-size: 32px;
  margin-bottom: 12px;
`;

const StatusDescription = styled.div`
  font-size: 20px;
  margin-bottom: 40px;
  white-space: break-spaces;
  max-width: 500px;
`;

const Explosion: any = styled.img.attrs(() => ({
  src: '/404/images/explosion.gif',
}))`
  width: 150px;
  position: absolute;
  left: ${(props: any) => props.position.x}px;
  top: ${(props: any) => props.position.y}px;
  transform: translate(-50%, -50%);
  visibility: ${(props: any) => (props.shouldShow ? 'visible' : 'hidden')};
`;

const showExplosion = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const ExplosionRandom = styled.img`
  position: absolute;
  animation: ${showExplosion} 700ms forwards;
`;

const ExtraContent = styled.div<{ shouldShake: Boolean }>`
  display: flex;
  margin-bottom: var(--p-spacing-08);
  flex: 0 0 auto;
  animation: ${(props) => (props.shouldShake ? violentShake : 'none')} 0.5s
    linear infinite;
`;

export default {
  StatusCode,
  StatusMesssage,
  StatusDescription,
  Explosion,
  ExplosionRandom,
  RainDrop,
  ExtraContent,
};
